import React from 'react';
import { SvgIcon } from '@gik/ui';
import Tooltip from '@gik/ui/Tooltip';
import AddToWishlistPopover from '../AddToWishlistPopover/AddToWishlistPopover';
import AddToFavouritesButton from '../AddToFavouritesButton/AddToFavouritesButton';
import RemoveFromWishlistButton from '../RemoveFromWishlistButton';
import { useUserOwnedOrOrganizingPages } from '@gik/api/inkinds/userPages';
import { useUserStore } from '@gik/core/store/UserStore';
import bemBlock from '@gik/core/utils/bemBlock';

export interface IProductTileToolbarProps {
  inkindRouteId?: string;
  itemId?: number;
  hasRemoveFromCurrentPageButton?: boolean;
}

export default function ProductTileToolbar({
  itemId,
  inkindRouteId,
  hasRemoveFromCurrentPageButton,
}: IProductTileToolbarProps): React.ReactElement {
  const userStore = useUserStore();
  const { data: inkindPages } = useUserOwnedOrOrganizingPages(userStore.id);

  // TODO: share code with ProductActions
  const addToWishlist = Boolean(
    inkindPages?.length !== 1 || !inkindPages[0].wishlistProductIds?.some(id => id === itemId)
  );

  // TODO: add translations
  const bem = bemBlock('product-tile-toolbar');
  return (
    <div
      className={bem()}
      onClick={ev => {
        // prevent things behind the toolbar from being clicked
        ev.stopPropagation();
      }}
    >
      <AddToFavouritesButton
        type="products"
        itemId={itemId?.toString()}
        child={(onClick, _isLoading, isFavourited) => {
          const tooltip = isFavourited ? 'SAVED TO FAVOURITES' : 'SAVE TO FAVOURITES';
          const icon = isFavourited ? 'Heart' : 'HeartOutline';
          const className = isFavourited ? bem('icon-heart-saved') : bem('icon-heart');
          return (
            <Tooltip text={tooltip}>
              <a onClick={onClick}>
                <SvgIcon className={className} size="xl" name={icon} />
              </a>
            </Tooltip>
          );
        }}
      />

      {(addToWishlist || !hasRemoveFromCurrentPageButton) && (
        <AddToWishlistPopover
          productId={itemId}
          inkindRouteId={inkindRouteId}
          child={onClick => (
            <Tooltip text={addToWishlist ? 'ADD TO WISHLIST' : 'REMOVE FROM WISHLIST'}>
              <a className={bem('icon-plus-btn')} onClick={onClick}>
                <SvgIcon
                  className={bem('icon-plus')}
                  size="2xl"
                  name={addToWishlist ? 'PlusOutline' : 'MinusOutline'}
                />
              </a>
            </Tooltip>
          )}
        />
      )}

      {hasRemoveFromCurrentPageButton && (
        <RemoveFromWishlistButton
          inkindRouteId={inkindRouteId}
          itemId={itemId}
          child={onClick => {
            return (
              <Tooltip text="REMOVE PRODUCT">
                <a onClick={onClick}>
                  <SvgIcon className={bem('icon-trash')} size="xl" name="TrashOutline" />
                </a>
              </Tooltip>
            );
          }}
        />
      )}
    </div>
  );
}
